<template>
    <span class="tooltip-container">
        <span class="tooltip">
            <span class="tooltiptext"><slot></slot></span>
        </span>
    </span>
</template>

<script lang="ts">
import {Options} from 'vue-class-component';
import {Vue} from 'vue-class-component';

@Options({
    name: 'Tooltip',
    components: {},
    props: {}
})

export default class Tooltip extends Vue {
}
</script>

<style lang="scss">

.tooltip-container {
    top:0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.tooltip {
    width: 0;
    position: relative;
}


.tooltip .tooltiptext {
    white-space: nowrap;
    font-size: .8rem;
    visibility: hidden;
    min-width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    transform: translateX(-50%) translateY(-100%);
    opacity: 0;
    transition: opacity 0.3s;
    //transition-delay: .5s;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 0;
    left: calc(50% - 4px);
    margin-top: 28px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.tooltip-activator:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}

</style>